import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import API_URLS from '../summaryapi/apiUrls';
import DataTable1 from '../components/datatableforassigin/DataTable1';
import './AssignOrders.css';
import { RingLoader } from 'react-spinners';

const AssignOrders = () => {
    const [serviceDetails, setServiceDetails] = useState(null);
    const [userDetails, setUserDetails] = useState(null);
    const [bookingDetails, setBookingDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedProviderId, setSelectedProviderId] = useState('');
    const [providers, setProviders] = useState([]);
    const [providerDetails, setProviderDetails] = useState(null);
    const [isScheduled, setIsScheduled] = useState(false); // State for scheduling status
    const [isAssigned, setIsAssigned] = useState(false); // Track if provider has been assigned

    const encodedProviderId = sessionStorage.getItem('provider_id');
    const SessionproviderId = encodedProviderId ? atob(encodedProviderId) : null;
    useEffect(() => {
        const fetchData = async () => {
            const queryParams = new URLSearchParams(window.location.search);

            // Retrieve the Base64 encoded parameters
            const encodedServiceId = queryParams.get('service_id');
            const encodedUserId = queryParams.get('user_id');
            const encodedBookingId = queryParams.get('booking_id');
            const encodedProviderId = queryParams.get('provider_id');
            
            // Decode the parameters from Base64
            const serviceId = encodedServiceId ? atob(encodedServiceId) : null;
            const userId = encodedUserId ? atob(encodedUserId) : null;
            const bookingId = encodedBookingId ? atob(encodedBookingId) : null;
            const providerId = encodedProviderId ? atob(encodedProviderId) : null;
            try {
                // Fetch Service Details
                const serviceResponse = await fetch(API_URLS.getServiceById.url, {
                    method: API_URLS.getServiceById.method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ service_id: serviceId }),
                });

                <div className=""></div>
                if (serviceResponse.ok) {
                    const serviceData = await serviceResponse.json();
                    if (serviceData.success) {
                        setServiceDetails(serviceData.data);
                    }
                }

                // Fetch User Details
                const userResponse = await fetch(API_URLS.getCustomerReportById.url, {
                    method: API_URLS.getCustomerReportById.method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user_id: userId }),
                });

                if (userResponse.ok) {
                    const userData = await userResponse.json();
                    if (userData.status) {
                        setUserDetails(userData.data);
                    } else {
                        toast.error('Failed to fetch user details.');
                    }
                } else {
                    toast.error('Failed to fetch user details.');
                }

                // Fetch Booking Details
                const bookingResponse = await fetch(API_URLS.getBookingDetails.url, {
                    method: API_URLS.getBookingDetails.method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ booking_id: bookingId }),
                });

                if (bookingResponse.ok) {
                    const bookingData = await bookingResponse.json();
                    if (bookingData.status) {
                        setBookingDetails(bookingData.data[0]);
                        setIsScheduled(bookingData.data[0].status === 'Scheduled');
                        setIsAssigned(providerId !== null); // Check if a provider is already assigned
                        // If there's a provider ID in the query string, pre-select the provider
                        if (providerId) {
                            setSelectedProviderId(providerId);
                            const selectedProviderData = bookingData.data[0].provider_id;
                            setProviderDetails(providers.find(provider => provider.provider_id === selectedProviderData));
                            
                        }
                    } else {
                        toast.error('Failed to fetch booking details.');
                    }
                } else {
                    toast.error('Failed to fetch booking details.');
                }

                // Fetch All Provider Details
                const providerResponse = await fetch(API_URLS.getAllProviderDetails.url, {
                    method: API_URLS.getAllProviderDetails.method,
                    headers: { 'Content-Type': 'application/json' },
                });

                if (providerResponse.ok) {
                    const providerData = await providerResponse.json();
                    const sortedProviders = providerData.data.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));

                    if (providerData.status) {
                        
                        setProviders(sortedProviders);
                        // If provider ID exists in query params, select it
                        if (providerId) {
                            const selectedProviderData = providerData.data.find(provider => provider.provider_id === providerId);
                            if (selectedProviderData) {
                                setProviderDetails(selectedProviderData);
                            }
                        }
                    }
                }

            } catch (error) {
                console.error('Error:', error);
                toast.error('An error occurred while fetching data.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleProviderChange = (e) => {
        const providerId = e.target.value;
        setSelectedProviderId(providerId);

        if (providerId) {
            const selectedProviderData = providers.find(provider => provider.provider_id === providerId);
            if (selectedProviderData) {
                setProviderDetails(selectedProviderData);
                setIsAssigned(false); // Reset the assigned status when selecting a new provider
            }
        } else {
            setProviderDetails(null);
            setIsAssigned(false); // Reset the assigned status if no provider is selected
        }
    };

    const handleAssign = async () => {
        // Step 1: Check if a provider is selected
        if (!selectedProviderId) {
            toast.error('Please select a provider to assign.'); // Show error if no provider selected
            return;
        }
    
        // Step 2: Find the selected provider details
        const selectedProviderData = providers.find(provider => provider.provider_id === selectedProviderId);
        if (!selectedProviderData) {
            toast.error('Provider not found.'); // Show error if provider is not found in the list
            return;
        }
    
        // Step 3: Ask for user confirmation before proceeding with the assignment
        const userConfirmed = window.confirm(`Are you sure you want to assign ${selectedProviderData.name} to this booking?`);
        if (!userConfirmed) {
            return; // If the user cancels the action, stop the process
        }
    
        // Step 4: Try to make the API request to assign the provider
        try {
            const response = await fetch(API_URLS.updateBookingDetails.url, {
                method: API_URLS.updateBookingDetails.method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    booking_id: bookingDetails.booking_id,
                    provider_id: selectedProviderId,
                    status: 'Confirmed',
                }),
            });
    
            // Step 5: Check if the response was successful
            if (!response.ok) {
                throw new Error('Failed to update booking details'); // If the response is not OK, throw an error
            }
    
            // Step 6: Process the response data
            const data = await response.json();
            if (data.success) {
                toast.success(`Provider assigned successfully to ${selectedProviderData.name}`); // Success message
                setIsAssigned(true); // Update the assignment status
            } else {
                toast.error('Failed to update booking details.'); // If the assignment fails, show an error
            }
        } catch (error) {
            console.error('Error updating booking details:', error);
            toast.error('An error occurred while updating booking details.'); // If any error occurs during the API call, show an error
        }
    };
    

    const handleSchedule = async () => {
        // Step 1: Ask for user confirmation before scheduling the booking
        const userConfirmed = window.confirm(`Are you sure you want to schedule this booking?`);
        if (!userConfirmed) {
            return; // If the user cancels, stop the process
        }
    
        try {
            // Step 2: Make the API request to update the booking status to 'Scheduled'
            const response = await fetch(API_URLS.updateBookingDetails.url, {
                method: API_URLS.updateBookingDetails.method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    booking_id: bookingDetails.booking_id,
                    provider_id: SessionproviderId,
                    status: 'Scheduled',
                }),
            });
    
            // Step 3: Check if the response was successful
            if (!response.ok) throw new Error('Failed to update booking details');
            const data = await response.json();
    
            // Step 4: If successful, update the status and show a success message
            if (data.success) {
                setIsScheduled(true); // Update scheduling status
                toast.success('Booking scheduled successfully.');
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                toast.error('Failed to schedule booking.');
            }
        } catch (error) {
            console.error('Error scheduling booking details:', error);
            toast.error('An error occurred while scheduling booking details.');
        }
    };
    

    const handleCancel = async () => {
        // Step 1: Ask for user confirmation before cancelling the booking
        const userConfirmed = window.confirm('Are you sure you want to cancel this booking?');
        if (!userConfirmed) {
            return; // If the user cancels, stop the process
        }
    
        try {
            // Step 2: Make the API request to update the booking status to 'Cancelled'
            const response = await fetch(API_URLS.updateBookingDetails.url, {
                method: API_URLS.updateBookingDetails.method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    booking_id: bookingDetails.booking_id,
                    provider_id: SessionproviderId,
                    status: 'Cancelled',
                }),
            });
    
            // Step 3: Check if the response was successful
            if (!response.ok) throw new Error('Failed to cancel booking');
            const data = await response.json();
    
            // Step 4: If successful, update the status and show a success message
            if (data.success) {
                setIsScheduled(false); // Reset scheduling status
                toast.success('Booking cancelled successfully.');
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                toast.error('Failed to cancel booking.');
            }
        } catch (error) {
            console.error('Error cancelling booking:', error);
            toast.error('An error occurred while cancelling booking.');
        }
    };
    

    if (loading) {
        return (
            <div className="loading-spinner">
                <h4>Please Wait.....</h4>
                <RingLoader color="#3498db" loading={loading} size={50} />
            </div>
        );
    }

    const columns = [
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'mobile_number', label: 'Mobile No' },
        { key: 'address', label: 'Address' },
        { key: 'category_name', label: 'Category' },
    ];

    return (
        <div className="card-body">
         <div className="booking-info col-12">
         <div className="d-flex justify-content-between align-items-center">
    <div className="booking-code-box flex-start">
        <p><strong>Booking Code:</strong> <span className="value">{bookingDetails ? bookingDetails.booking_code : 'N/A'}</span></p>
    </div>
    <h3 className="card-title mx-auto mb-2">Assigning Orders</h3>
</div>



                <hr />
                <div className="user-service-info">
 
                    {serviceDetails?.service_img1 && (
                        <img 
                            src={`${API_URLS.getsevicesImages.url}${serviceDetails.service_img1}`} 
                            alt={serviceDetails.service_name} 
                            className="img-fluid service-image"
                        />
                    )}
                </div>
                <div className="info-container">
                    <div className="users-info card smaller-card cardanimated">
                        <h1 className="text-center underlined">Service Details</h1>
                        <div className="user-details">
                            <p><strong>Service Name:</strong> <span className="value">{serviceDetails ? serviceDetails.service_name : 'N/A'}</span></p>
                            <p><strong>Booking Date:</strong> <span className="value">{bookingDetails ? new Date(bookingDetails.booking_date).toLocaleString() : 'N/A'}</span></p>
                            <p><strong>Service Price:</strong> <span className="value">₹{bookingDetails ? bookingDetails.service_price : 'N/A'}</span></p>
                            <p><strong>Service Date:</strong> <span className="value">{bookingDetails ? bookingDetails.service_date : 'N/A'}</span></p>
                            <p><strong>Service Time:</strong> <span className="value">{bookingDetails ? bookingDetails.service_time : 'N/A'}</span></p>
                        </div>
                    </div>
                    <div className="users-info card smaller-card">
                            <h1 className="text-center underlined">User Details</h1>
                            <div className="user-details">
                                <p><strong>Name:</strong> <span className="value">{userDetails ? userDetails.name : 'N/A'}</span></p>
                                <p><strong>Email:</strong> <span className="value">{userDetails ? userDetails.email : 'N/A'}</span></p>
                                <p><strong>Mobile No:</strong> <span className="value">{userDetails ? userDetails.MobileNo : 'N/A'}</span></p>
                                <p><strong>Address:</strong> <span className="value">{userDetails ? userDetails.address : 'N/A'}</span></p>
                  
                        </div>
                    </div>
                </div>
                <span className={`booking-status ${bookingDetails?.status.toLowerCase()}`}>
                    {bookingDetails ? bookingDetails.status : 'N/A'}
                </span>
                { !SessionproviderId &&  
  <div className='flex justify-content-between'>
    <div className="provider-section" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
    
      {/* Provider Selection and Details */}
      <div className="provider-selection-wrapper" style={{ flex: '1' }}>
        <div className="provider-assign">
          <label className="selectproviders">Select Providers:</label>
          <select 
              className="selectproviders" 
              value={selectedProviderId} 
              onChange={handleProviderChange}
          >
            <option value="">Select Provider</option>
            {providers.map((provider) => (
              <option key={provider.provider_id} value={provider.provider_id}>
                {provider.name}
              </option>
            ))}
          </select>
          
          {selectedProviderId && (
            <div className="selected-provider">
              Selected Provider: {providerDetails?.name}
              <p><strong>Category Name:</strong> <span className="value">{providerDetails ? providerDetails.category_name : 'N/A'}</span></p>
            </div>
          )}
        </div>

        <div className="provider-details card smaller-card cardanimated">
          <div className="user-details">
            <h5 className="card-title text-center underlined">Provider Details</h5>
            <p><strong>Name:</strong> <span className="value">{providerDetails ? providerDetails.name : 'N/A'}</span></p>
            <p><strong>Email:</strong> <span className="value">{providerDetails ? providerDetails.email : 'N/A'}</span></p>
            <p><strong>Mobile No:</strong> <span className="value">{providerDetails ? providerDetails.mobile_number : 'N/A'}</span></p>
            <p><strong>Address:</strong> <span className="value">{providerDetails ? providerDetails.address : 'N/A'}</span></p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <button 
              style={{
                backgroundColor: isAssigned ? 'red' : '#007bff', 
                color: 'white', 
                border: 'none', 
                padding: '10px 20px', 
                cursor: selectedProviderId ? 'pointer' : 'not-allowed', 
                borderRadius: '5px', 
                opacity: selectedProviderId ? 1 : 0.6
              }}
              onClick={handleAssign}
              disabled={!selectedProviderId}
            >
              {isAssigned ? 'Assigned' : 'Assign'}
            </button>
          </div>
        </div>
      </div>

      <div className="provider-list">
    <DataTable1 data={providers} columns={columns} />
</div>

    </div>
  </div>
}


{SessionproviderId && 
    (<div className="action-buttons">
        <div className="d-flex justify-content-between text-center">
            {/* Schedule Button */}
            {!isScheduled && (
                <button className="btn btn-primary" onClick={handleSchedule}>Schedule</button>
            )}
    
            {/* Cancel Button */}
            {isScheduled && (
      <button 
      className="btn btn-danger" 
      onClick={handleCancel} 
      style={{ backgroundColor: 'red' }}
    >
      Cancel
    </button>
    
            )}
        </div>
    </div>
    )
}
            </div>


        </div>
    );
};

export default AssignOrders;
